export const german = {
  feedback: {
    "title": "Feedback senden",
    "category": "Kategorie",
    "suggestion": "Vorschlag",
    "problem": "Problem",
    "other": "Sonstiges",
    "message": "Dein Feedback",
    "placeholder": "Was würdest du verbessern oder was hat nicht funktioniert?",
    "email": "E-Mail für Rückfragen (optional)",
    "send": "Feedback senden",
    "sending": "Wird gesendet…",
    "success": "Danke — dein Feedback ist angekommen.",
    "error": "Dein Feedback konnte nicht gesendet werden. Der Text bleibt erhalten; versuche es erneut.",
    "invalid": "Gib 10–3.000 Zeichen und gegebenenfalls eine gültige E-Mail ein.",
    "signIn": "Zum Senden anmelden",
    "inbox": "Nutzerfeedback",
    "empty": "Noch kein Feedback.",
    "reviewed": "Gelesen",
    "markReviewed": "Als gelesen markieren",
    "refresh": "Aktualisieren",
    "new": "Neu"
},
  menu: {
    signOut: "Abmelden",
    signIn: "Anmelden / Registrieren",
    talkToUs: "Kontaktiere uns",
    language: "Sprache",
    deleteAccount: "Konto Löschen",
    accountSettings: "Kontoeinstellungen",
  },
  theme: {
    light: "Hell",
    dark: "Dunkel",
  },
  landing: {
    heroKicker: "Für Bürger und Gemeinden weltweit",
    heroSub: "Wir übermitteln deine Stimme an die Gemeinde — weltweit.",
    municipalityLogin: "Kommunen-Login",
    pecCardTitle: "Jede Meldung erreicht Gemeinden weltweit",
    pecBadge: "E-Mail",
    pecCardBody: "Aus jeder Stadt, in jedem Land. Partner-Gemeinden erhalten Meldungen direkt; wo eine Gemeinde noch nicht partner ist, leiten wir jede Meldung per E-Mail an die zuständigen Behörden weiter, damit kein Problem übersehen wird.",
    pecTitle: "Jede Meldung zählt – auch ohne Partnerschaft",
    pecBody: "Wenn deine Gemeinde noch kein ShapeIt-Partner ist, senden wir jede Meldung dennoch per E-Mail an die zuständigen Behörden, damit kein Problem übersehen wird.",
    pecHighlight: "Wir leiten Meldungen per E-Mail an die Gemeinden weiter",
    ctaSub: "Schließe dich Bürgern und Gemeinden auf der ganzen Welt an und bewirke etwas — Meldung für Meldung.",
  },
  mapHeader: {
    appName: "Shapeit",
    login: "Anmelden / Registrieren",
    searchPlaceholder: "Orte suchen oder irgendwo auf die Karte klicken, um ein Problem zu melden",
    clearSearch: "Suche löschen",
  },
  mapLegend: {
    title: "Shapeit Legende",
    buttonLabel: "Legende",
    dirty: "Verschmutzt",
    unsafe: "Unsicher",
    needsFix: "Reparaturbedürftig",
  },
  dialog: {
    selectLanguage: "Wähle deine bevorzugte Sprache",
    chooseLanguage: "Wähle eine Sprache für die Anwendungsoberfläche.",
    confirm: "Bestätigen",
    welcome: {
      title: "Willkommen!",
      message: "Shapeit ist hier, um dich zu stärken. Wir möchten, dass du deine Stadt gestalten und zu einem besseren Ort machen kannst. Jedes Mal, wenn du ein Problem entdeckst, kannst du es melden und auch die Meldungen anderer Nutzer liken, um ihnen mehr Sichtbarkeit zu verleihen. Wir sorgen dafür, dass die Stadtbehörden über die dringendsten Probleme auf dem Laufenden gehalten werden.",
      message2: "Shapeit arbeitet daran, Partnerschaften mit Gemeinden weltweit aufzubauen. Auch wenn deine Stadt noch kein Partner ist, leiten wir jede Meldung per E-Mail an die zuständigen Behörden weiter, damit kein Problem übersehen wird. Jede Meldung trägt dazu bei, eine aktuelle Datenbank der städtischen Probleme in deiner Region zu erstellen: Je mehr wir sammeln, desto stärker wird unsere Stimme sein, wenn wir uns an die lokalen Behörden wenden. Jetzt geh und mach deine Stadt zu einem besseren Ort!",
      next: "Weiter",
      button: "Los geht's!"
    }
  },
  reports: {
    overview: "Berichte Übersicht",
    trending: "Trending",
    myReports: "Meine Berichte",
    yourReports: "Deine Berichte",
    recentReports: "Neueste Berichte",
    by: "von",
    anonymous: "Anonym",
  },
  usernameSetup: {
    title: "Wähle deinen Benutzernamen",
    description: "Wähle einen öffentlichen Namen für deine Meldungen. Du kannst ihn später in den Kontoeinstellungen ändern.",
    placeholder: "Dein Benutzername",
    save: "Speichern",
    saving: "Speichern...",
    skip: "Später",
    tooShort: "Der Benutzername muss mindestens 2 Zeichen haben",
    noEmail: "Der Benutzername darf kein @ enthalten",
    success: "Benutzername gespeichert",
    error: "Benutzername konnte nicht gespeichert werden",
  },
  reportForm: {
    postAnonymously: "Anonym veröffentlichen",
    postAnonymouslyHint: "Dein Name wird bei dieser Meldung nicht angezeigt.",
    postingAs: "Veröffentlichen als",
    title: "Bericht einreichen",
    description: "Beschreibung",
    uploadPhoto: "Foto hochladen",
    takePhoto: "Foto aufnehmen",
    changePhoto: "Foto ändern",
    preview: "Vorschau",
    submit: "Bericht einreichen",
    submitting: "Wird eingereicht...",
    loginRequired: "Du musst angemeldet sein, um einen Bericht einzureichen",
    uploadFailed: "Bericht konnte nicht hochgeladen werden",
    photoUploadFailed: "Das Foto konnte nicht gesendet werden. Dein Bericht ist noch da.",
    sendWithoutPhoto: "Ohne Foto senden",
    selectIssue: "Bitte wähle eine Problemkategorie aus",
    selectIssueType: "Wähle eine Problemkategorie aus",
    moderationWarning: "Berichte werden automatisch moderiert. Beleidigende, Spam- oder unangemessene Inhalte werden abgelehnt.",
    rejectedContent: "Ihr Bericht enthält unangemessene Inhalte und kann nicht veröffentlicht werden",
    rateLimitExceeded: "Sie haben das Limit von 5 Berichten pro Stunde erreicht. Bitte versuchen Sie es später erneut.",
    characterLimit: "Die Beschreibung darf 500 Zeichen nicht überschreiten",
    appealLink: "Einspruch per E-Mail einreichen",
    offensiveContent: "Ihre Nachricht enthält unangemessene Sprache",
    validatingImage: "Bild wird überprüft...",
        aiAnalyzing: "KI analysiert...",
    duplicateWarning: "Ein ähnlicher Bericht existiert bereits in der Nähe. Erwäge, ihn hochzuvoten, anstatt ein Duplikat zu erstellen.",
    aiSuggestions: "KI-Vorschläge",
    suggestedTitle: "Vorgeschlagener Titel:",
    priority: "Priorität:",
    inappropriateImage: "Das Bild enthält unangemessene Inhalte und kann nicht verwendet werden",
    notRelevantImage: "Das Foto scheint kein städtisches Problem zu zeigen. Bitte lade ein Foto des Problems hoch, das du melden möchtest.",
  },
  confirmReport: {
    question: "Möchtest du hier einen Bericht erstellen?",
    yes: "Ja",
    no: "Nein"
  },
  locationPrompt: "Klicke auf die gewünschte Stelle, um ein Problem zu melden",
  reportHere: "Hier melden",
  deleteAccount: {
    title: "Konto löschen",
    warning: "Diese Aktion ist unwiderruflich!",
    description: "Alle Ihre Daten werden dauerhaft gelöscht, einschließlich:",
    items: {
      reports: "Alle Ihre Berichte",
      photos: "Alle hochgeladenen Fotos",
      accountData: "Ihre Kontoinformationen"
    },
    confirmLabel: "Geben Sie DELETE ein, um zu bestätigen",
    confirmPlaceholder: "DELETE",
    cancel: "Abbrechen",
    deleteButton: "Mein Konto Löschen",
    deleting: "Wird gelöscht...",
    success: "Konto erfolgreich gelöscht",
    error: "Fehler beim Löschen des Kontos"
  },
  gamification: {
    totalReports: "Meldungen gesamt",
    congratulations: "Herzlichen Glückwunsch!",
    pointsEarned: "Punkte verdient",
    totalPoints: "Gesamtpunkte",
    currentLevel: "Aktuelles Level",
    levelUp: "Level aufgestiegen!",
    nextLevel: "Nächstes Level",
    progress: "Fortschritt",
    thankYou: "Danke, dass Sie die Stadt zu einem besseren Ort machen!",
    keepGoing: "Melden Sie weiter, um das nächste Level zu erreichen!",
    continue: "Weiter",
    levels: {
      beginner: "Anfänger",
      active_citizen: "Aktiver Bürger",
      urban_observer: "Stadt-Beobachter",
      city_guardian: "Stadt-Wächter",
      civic_champion: "Bürger-Champion",
      urban_hero: "Stadt-Held"
    },
    messages: {
      beginner: "Willkommen in der Gemeinschaft!",
      active_citizen: "Sie machen einen Unterschied!",
      urban_observer: "Ihre Augen machen die Stadt besser!",
      city_guardian: "Sie sind ein wahrer Wächter!",
      civic_champion: "Champion der Bürgerpflicht!",
      urban_hero: "Sie sind ein Stadt-Held!"
    }
  },
  onboarding: {
    step1: {
      title: "Willkommen auf der Karte!",
      description: "Hier können Sie alle Meldungen aus Ihrer Gemeinde sehen. Lernen wir, wie man sie benutzt!"
    },
    step2: {
      title: "Erstellen Sie eine Meldung",
      description: "Suchen Sie nach einem Ort oder klicken Sie auf die Karte, um eine neue Meldung über ein Problem in Ihrer Gegend zu erstellen."
    },
    step3: {
      title: "Meldungstypen",
      description: "Verschiedene Farben stehen für verschiedene Arten von Problemen. Klicken Sie auf Markierungen, um Details zu sehen und Meldungen, die Ihnen wichtig sind, hochzustimmen!"
    },
    step4: {
      title: "Ihr Profil & Gamification",
      description: "Verdienen Sie Punkte, indem Sie Meldungen erstellen und Ihrer Gemeinde helfen! Verfolgen Sie hier Ihr Level und Ihren Fortschritt."
    },
    step5: {
      title: "Sie sind bereit!",
      description: "Beginnen Sie, Ihre Gemeinde zu verbessern, indem Sie Probleme melden und sich mit anderen Meldungen auseinandersetzen. Jeder Beitrag zählt!"
    },
    previous: "Zurück",
    next: "Weiter"
  },
    accountSettings: {
    title: "Kontoeinstellungen",
    openSettings: "Kontoeinstellungen",
    changeEmail: "E-Mail ändern",
    newEmailLabel: "Neue E-Mail-Adresse",
    newEmailPlaceholder: "neue@email.com",
    changePassword: "Passwort ändern",
    newPasswordLabel: "Neues Passwort",
    newPasswordPlaceholder: "Mindestens 6 Zeichen",
    passwordTooShort: "Das Passwort muss mindestens 6 Zeichen lang sein",
    passwordSuccess: "Passwort erfolgreich aktualisiert",
    changeUsername: "Benutzername ändern",
    newUsernameLabel: "Neuer Benutzername",
    newUsernamePlaceholder: "Dein Benutzername",
    usernameTooShort: "Der Benutzername muss mindestens 2 Zeichen lang sein",
    usernameSuccess: "Benutzername erfolgreich aktualisiert",
    deleteAccountTitle: "Konto löschen",
    deleteAccountDescription: "Lösche dein Konto und alle zugehörigen Daten dauerhaft. Diese Aktion kann nicht rückgängig gemacht werden.",
    deleteAccountButton: "Konto löschen",
    save: "Speichern",
    saving: "Wird gespeichert...",
    submit: "Bestätigungs-E-Mail senden",
    submitting: "Wird gesendet...",
    invalidEmail: "Ungültige E-Mail-Adresse",
    error: "Fehler",
    updateFailed: "Aktualisierung fehlgeschlagen",
    successTitle: "Bestätigungs-E-Mail gesendet",
    successDescription: "Wir haben eine Bestätigungs-E-Mail an {email} gesendet. Überprüfen Sie Ihr Postfach, um die Änderung zu bestätigen.",
    showPassword: "Passwort anzeigen",
    hidePassword: "Passwort verbergen",
  },
  push: {
    title: "Push-Benachrichtigungen",
    subtitle: "Verwalte die Benachrichtigungen auf deinem Gerät",
    enable: "Push-Benachrichtigungen aktivieren",
    denied: "Berechtigung verweigert. Aktiviere Benachrichtigungen in den Geräteeinstellungen.",
    registered: "Gerät registriert",
    requestPermission: "Berechtigung für Benachrichtigungen anfordern",
    resolved: "Meldung gelöst",
    resolvedDesc: "Wenn eine deiner Meldungen gelöst wird",
    upvotes: "Erhaltene Upvotes",
    upvotesDesc: "Wenn jemand deine Meldungen unterstützt",
    achievements: "Freigeschaltete Erfolge",
    achievementsDesc: "Wenn du einen neuen Erfolg freischaltest",
    newReports: "Neue Meldungen",
    newReportsDesc: "Wenn neue Meldungen erstellt werden",
    updated: "Einstellungen aktualisiert",
    updateError: "Einstellungen konnten nicht aktualisiert werden",
    mobileOnly: "Push-Benachrichtigungen werden in der mobilen App zugestellt",
  },
  referral: {
    inviteTitle: "Lade Freunde ein und sammle Punkte!",
    inviteSubtitle: "Erstelle deinen Einladungscode und erhalte 50 Punkte für jeden Freund, der sich anmeldet.",
    createCode: "Einladungscode erstellen",
    yourCode: "Dein Einladungscode",
    copy: "Kopieren",
    codeCopied: "Code in die Zwischenablage kopiert!",
    linkCopied: "Einladungslink kopiert!",
    directLink: "Direktlink",
    stats: "Einladungsstatistik",
    completed: "Abgeschlossen",
    pending: "Ausstehend",
    total: "Gesamt",
    ambassadorProgress: "Botschafter-Fortschritt",
    ambassadorUnlocked: "Du hast das Botschafter-Abzeichen freigeschaltet!",
    shareText: "Mach mit bei ShapeIt und verbessere deine Stadt! Nutze meinen Code {code} für 50 Bonuspunkte 🎁",
    shareTitle: "ShapeIt-Einladung",
  },
  misc: {
    mapLoadFailed: "Karte konnte nicht geladen werden",
    mapKeyError: "Google-Maps-API-Schlüssel konnte nicht geladen werden",
    mapKeyMissing: "Google-Maps-API-Schlüssel nicht konfiguriert",
    mapsLoadError: "Google Maps konnte nicht geladen werden",
    onlyImages: "Nur JPEG-, PNG- und WebP-Bilder sind erlaubt",
    imageTooLarge: "Das Bild muss kleiner als 5 MB sein",
    photoFailed: "Foto konnte nicht aufgenommen werden",
    current: "Aktuell",
    progress: "Fortschritt",
  },
  common: {
    share: "Teilen",
    shareTitle: "Diese Meldung teilen",
    copyLink: "Link kopieren",
    linkCopied: "Link in die Zwischenablage kopiert!",
    copyFailed: "Link konnte nicht kopiert werden",
    loading: "Lädt...",
    close: "Schließen",
    delete: "Löschen",
    cancel: "Abbrechen",
    retry: "Erneut versuchen",
    login: "Anmelden",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    username: "Benutzername",
    anonymous: "Anonym",
    notYourReport: "Nicht deine Meldung",
    loginToDelete: "Zum Löschen anmelden",
    upvotes: "Stimmen",
    reportedBy: "Gemeldet von",
    trending: "Im Trend",
    trendingReports: "Meldungen im Trend",
    noTrending: "Noch keine Meldungen im Trend",
    yourReports: "Deine Meldungen",
    noReportsYet: "Du hast noch keine Meldungen erstellt",
    loadingAddress: "Adresse wird geladen…",
    myLocation: "Mein Standort",
    yourLocation: "Dein Standort",
    mapView: "Kartenansicht",
    satelliteView: "Satellitenansicht",
    changePhoto: "Foto ändern",
    uploadingPhoto: "Wird hochgeladen...",
    photoUpdated: "Profilbild aktualisiert",
    photoUploadError: "Foto konnte nicht hochgeladen werden",
    removePhoto: "Foto entfernen",
    inviteFriends: "Freunde einladen",
    achievements: "Erfolge",
    noAchievements: "Noch keine Erfolge freigeschaltet",
    statusHistory: "Statusverlauf",
    seeTranslation: "Übersetzung anzeigen",
    seeOriginal: "Original anzeigen",
    translating: "Wird übersetzt...",
    translationFailed: "Übersetzung nicht verfügbar",
    translatedAutomatically: "Automatisch übersetzt",
    deleteConfirm: "Möchtest du diese Meldung löschen?",
    loginToDeleteReports: "Bitte melde dich an, um Meldungen zu löschen",
    onlyOwnReports: "Du kannst nur eigene Meldungen löschen",
  },
  auth: {
    backToMap: "Zurück zur Karte",
    subtitle: "Melde dich an oder erstelle ein Konto, um Probleme in deiner Umgebung zu melden",
    login: "Anmelden",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    username: "Benutzername",
    orContinueWith: "Oder weiter mit",
    signInGoogle: "Mit Google anmelden",
    signUpGoogle: "Mit Google registrieren",
    signingIn: "Anmeldung läuft...",
    signIn: "Anmelden",
    referralLabel: "Einladungscode (optional) 🎁",
    referralPlaceholder: "Einladungscode eingeben",
    referralBonus: "Mit diesem Code erhältst du 50 Bonuspunkte! 🎁",
    creatingAccount: "Konto wird erstellt...",
    createAccount: "Konto erstellen",
    showPassword: "Passwort anzeigen",
    hidePassword: "Passwort verbergen",
  },
  analytics: {
    otherCategory: "Sonstiges",
    pageTitle: "Analytics-Dashboard",
    pageSubtitle: "Öffentliche Statistiken und Transparenz zu den Meldungen der Community",
    backToMap: "Zurück zur Karte",
    noData: "Keine Daten verfügbar",
    communityTitle: "Community-Analytics",
    communitySubtitle: "Echtzeit-Statistiken zu Bürgermeldungen",
    municipalityScopedSubtitle: "Echtzeit-Statistiken zu Meldungen in Ihrer Gemeinde",
    totalReports: "Meldungen gesamt",
    inProgress: "In Bearbeitung",
    resolved: "Gelöst",
    avgTime: "Durchschnittliche Dauer",
    categoryTitle: "Verteilung nach Kategorie",
    categoryDesc: "Arten der eingegangenen Meldungen",
    trendTitle: "Trend der letzten 7 Tage",
    trendDesc: "Anzahl der täglichen Meldungen",
    topAreasTitle: "Meistgemeldete Gebiete",
    topAreasDesc: "Gebiete mit den meisten aktiven Meldungen",
    adminTitle: "Erweiterte Analytics (Admin)",
    adminSubtitle: "Detaillierte Kennzahlen nur für Administratoren sichtbar",
    dau: "Täglich aktive Nutzer",
    wau: "Wöchentlich aktive Nutzer",
    mau: "Monatlich aktive Nutzer",
    avgSession: "Durchschnittliche Sitzungsdauer",
    minutesShort: "Min.",
    mapInteractions: "Karteninteraktionen",
    perSession: "Durchschnitt pro Sitzung",
    reportsPerUser: "Meldungen pro Nutzer",
    average: "Durchschnitt",
    completionRate: "Abschlussquote",
    loginToReport: "Login → Meldung",
    funnelTitle: "Conversion-Funnel",
    funnelDesc: "Analyse der Nutzerreise (letzte 7 Tage)",
    users: "Nutzer",
    conversionPct: "% Conversion",
    devicesTitle: "Geräteverteilung",
    devicesDesc: "Analyse der verwendeten Geräte",
  },
};
